import { render, staticRenderFns } from "./infoProdotto.vue?vue&type=template&id=40cf8b78&scoped=true&"
import script from "./infoProdotto.vue.ts?vue&type=script&lang=ts&"
export * from "./infoProdotto.vue.ts?vue&type=script&lang=ts&"
import style0 from "./infoProdotto.vue?vue&type=style&index=0&id=40cf8b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf8b78",
  null
  
)

export default component.exports